<template>

<div class="row">
        <!-- <div class="col-lg-4">
                <sau-utility-profile></sau-utility-profile>
        </div> -->
            <div class="col-md-12 col-md-offset-2">
                <form>
                        <!-- Blank field start-->
                        <div class="d-none" id="blank-id-wrapper">
                            <label>Keep this field blank</label>
                            <input type="text" name="blank-id" id="blank-id" />
                        </div>
                        <!-- Blank field end -->

                        <!-- Verification Code -->
                        <div class="form-row mb-2">
                            <div class="col">
                                <!-- <h5>Verify your {{method}}</h5> -->
                                <h5 v-if="!didSendCode">Enter new phone number</h5>
                                <h5 v-else>Please enter the verification code you just received to confirm your phone</h5>
                                <div class="form-group" v-if="!didSendCode">
                                    <div class="input-group mb-2">
                                        <vue-tel-input
                                            id="code"
                                            name="token"
                                            class="w-75"
                                            v-model="twoFactorDetails"
                                            :preferredCountries="['AU', 'US', 'GB', 'NZ']"
                                            :mode="'international'"
                                        />
                                    </div>
                                </div>
                                <div class="form-group" v-if="didSendCode">
                                    <div class="input-group mb-2">
                                        <input v-model="token" id="code" name="token" class="form-control" placeholder="Verification Code" dusk="two-factor-code" required autofocus>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Button -->
                        <div class="form-row">
                            <div class="col">
                                <button v-if="!didSendCode" type="submit" @click.prevent="didClick()" :disabled="shouldDisable || loading" dusk="two-factor-button" class="btn" :class="[shouldDisable ? 'btn-light' : 'btn-success']">{{buttonLabel}} <i v-if="loading" class="far fa-spinner-third fa-spin"></i></button>
                                <div class="mt-2 text-center text-danger">
                                    <span v-if="error">{{ error }}</span>
                                </div>

                                <button v-if="didSendCode" type="submit" @click.prevent="didClick()" :disabled="!canVerifyCode || loading" dusk="two-factor-button" class="btn" :class="[canVerifyCode ? 'btn-success' : 'btn-light']">{{buttonLabel}} <i v-if="loading" class="far fa-spinner-third fa-spin"></i></button>
                                <div class="mt-2 text-center text-danger">
                                    <span v-if="error">{{ error }}</span>
                                </div>
                            </div>
                        </div>
                    </form>
            </div>
    </div>


</template>

<script>
import { mapGetters } from 'vuex';
import { required, minLength, maxLength, numeric, email, sameAs } from 'vuelidate/lib/validators';
import { VueTelInput } from 'vue-tel-input';
// CustomValidator
export function isInternationalFormat (value) {
  return !!value.match(/^[1-9][0-9]{3,14}$/);
}

export default {
    props: {
        method: {
            type: String,
            required: true
        }
    },
    components: {
        VueTelInput,
    },
    data() {
        return {
            twoFactorDetails: '',
            buttonLabel: 'Send Code',
            didSendCode: false,
            token: '',
            loading: false,
            avatar: '/img/avatar.svg',
            error: '',
            verificationAttempts: 0,
            maxVerificationAttempts: 3
        }
    },
    methods:{
        didClick(){
            this.error = '';
            this.didSendCode ? this.attemptVerification() : this.requestVerificationCode()
        },
        resetPage(){
            this.didSendCode = false;
            this.buttonLabel = 'Send Code'
        },
        requestVerificationCode(){
            this.loading = true;
            this.buttonLabel = 'Sending Code'
            this.requestTwoFactorCode({ two_factor_method: this.method, two_factor_details: this.twoFactorDetails })
                .then((response) => {
                    this.buttonLabel = 'Verify Code'
                    this.didSendCode = true
                    this.loading = false
                })
                .catch((error) => {
                    this.loading = false
                    this.resetPage()
                    this.error = error.response.data.message
                });

        },
        attemptVerification(){
            if(!this.token){
                return this.error = 'Please enter your verification code'
            }

            this.verificationAttempts++;

            this.loading = true;
            this.buttonLabel = 'Verifying Code'
            this.sendTwoFactorResponse({token: this.token, two_factor_method: this.method, two_factor_details: this.twoFactorDetails})
                .then((response) => {
                    if(this.method === 'email'){
                        this.updateEmail()
                    } else {
                        window.location = '/account/security'
                    }
                })
                .catch((error) => {
                    this.loading = false
                    if(this.verificationAttempts > 2){
                       return window.location = this.method === 'mobile' ? '/account/security' : '/account/edit';
                    }
                    this.$swal({
                        type:'error',
                        title: 'Verification code does not match. You have '+this.remainingVerificationAttempts+' attempts left.',
                        showConfirmButton: false,
                        timer: 3000
                    });
                });
        },
        updateEmail() {
           this.buttonLabel = 'Updating Email';
            this.updateUserEmail({email: this.twoFactorDetails})
                .then((response) => {
                    /** Update email in vuex */
                    this.$store.commit('setUserField', ['email', this.twoFactorDetails]);
                    /** Update parent form property */
                    this.$parent.form.email = this.twoFactorDetails;
                    /** Hide form */
                    this.$store.commit('setDisplayEmailUpdateForm', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.resetPage()
                    this.$swal({
                        type:'error',
                        title: error.response.data.errors.email[0],
                        showConfirmButton: false,
                        timer: 3000
                    });
                });
        }
    },
    computed: {
        remainingVerificationAttempts(){
            return this.maxVerificationAttempts - this.verificationAttempts;
        },
        shouldDisable(){
            return (!this.didSendCode && !this.twoFactorDetails) || (this.didSendCode && !this.token)
        },
        canVerifyCode() {
            return /^\d{5,10}$/.test(this.token) ? true : false;
        },
    }
}
</script>
<style>
</style>
